import { render, staticRenderFns } from "./ComplementsGroups.vue?vue&type=template&id=f57b58c4"
import script from "./ComplementsGroups.vue?vue&type=script&lang=js"
export * from "./ComplementsGroups.vue?vue&type=script&lang=js"
import style0 from "./ComplementsGroups.vue?vue&type=style&index=0&id=f57b58c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports